<template>
  <div class="section has-black-gradient">
    <div class="columns is-vcentered">
      <div class="column has-text-right-desktop">
        <figure class="image is-inline-block">
          <img src="@/assets/img/chelita-3d.png" />
        </figure>
      </div>
      <div class="column">
        <div class="text-container">
          <p class="has-text-blue">¿Quiénes somos?</p>
          <p class="is-subtitle mt-3">Somos una empresa de desarrollo de software y productos digitales.</p>
          <p class="is-text mt-3">
            Desarrollamos aplicaciones móviles, tiendas en línea y software especializado para la administración de
            negocios.
          </p>
          <div class="line-divider"></div>
          <p class="has-text-light-blue">Nuestra misión</p>
          <p class="is-text mt-3">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="section has-padding-top-0">
    <div class="container">
      <div class="box-with-blue-gradient">
        <div class="box-text">
          <p class="is-box-title has-text-green">12+</p>
          <p class="is-text">Clientes satisfechos</p>
        </div>
        <div class="box-text">
          <p class="is-box-title has-text-orange">30+</p>
          <p class="is-text">Sitios digitalizados</p>
        </div>
        <div class="box-text">
          <p class="is-box-title has-text-red">50%</p>
          <p class="is-text">Reducción de más de medio millón al mes en costos de operación</p>
        </div>
      </div>
    </div>

    <div class="container has-text-centered is-text-section">
      <p class="has-text-blue">Nuestras herramientas</p>
      <p class="is-subtitle mt-3">Tecnologías competitivas en la industria</p>
      <p class="is-text mt-5">
        Nos valemos de herramientas probadas y utilizadas en la industria para construir las mejores soluciones
      </p>
      <div class="slider mt-5 is-inline-block">
        <slider class="" />
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "@/components/Utils/Slider.vue";

export default {
  name: "AboutUsDescription",
  components: { Slider },
};
</script>

<style scoped>
.section {
  padding-top: 150px;
  height: 700px;
  background: var(--Dark-Gray, #2C2C31);
}

.has-black-gradient {
  background: var(--Dark-gradient, linear-gradient(9deg, #2C2C31 0%, #18181A 86.48%));
}

figure {
  width: 65%;
}

.text-container {
  width: 60%;
}

.has-text-blue {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 5.4px;
  text-transform: uppercase;
}

.is-subtitle {
  font-size: 26px;
  font-weight: 600;
}

.is-text {
  font-size: 14px;
  font-weight: 600;
}

.line-divider {
  margin: 35px 0px;
  border-top: 1px solid #2489CA;
}

.has-text-light-blue {
  font-size: 20px;
  font-weight: 800;
}

.has-padding-top-0 {
  padding-top: 0;
}

.box-with-blue-gradient {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 40px 20px;
  border-radius: 8px;
  background: linear-gradient(90deg, #166B93 0%, #2489CA 48.33%, #15D9FD 99.79%);
  text-align: center;
  margin-top: 40px;
}

.box-text {
  flex: 1 1 200px;
  min-width: 200px;
}

.is-box-title {
  font-size: 36px;
  font-weight: 800;
}

.is-text-section {
  margin-top: 100px;
}

.slider {
  width: 95%;
}

.has-text-green {
  color: #23d160;
}

.has-text-orange {
  color: #ffdd57;
}

.has-text-red {
  color: #e0073a;
}

@media only screen and (max-width: 768px) {
  .section {
    padding-top: 50px;
    height: unset;
  }

  .text-container {
    width: fit-content;
  }

  figure {
    width: 100%;
  }

  .is-subtitle {
    font-size: 20px;
  }

  .box-with-blue-gradient {
    flex-direction: column;
    gap: 20px;
    height: auto;
    margin: 0 5%;
  }

  .is-box-title {
    font-size: 28px;
  }

  .is-text {
    font-size: 13px;
  }
}
</style>
